import { createSelector } from 'reselect'
import { createSelector as ormCreateSelector } from 'redux-orm'
import orm from '../../models/models'

export const products = createSelector(
  (state) => state.orm,
  ormCreateSelector(orm, (session) => {
    return session.Product.all().toModelArray()
  })
)

export const getProductRequestObj = (filters) => {
  let categories = []
  const filteredCategories = filters.categories
  for (const category in filters.categories) {
    const subcategories = filteredCategories[category]
    if (subcategories === 'all') {
      categories.push(category)
    } else {
      categories = categories.concat(subcategories)
    }
  }

  const order = filters.order
  const difficulties = filters.difficulties
  const intensities = filters.intensities
  const instructors = filters.instructors?.map((item) => item.slug)
  const focus_areas = filters['focus_area']?.map((item) => item)
  const equipments = filters.equipment?.map((item) => item)
  const excludeCompleted = filters.excludeCompleted
  const page = filters.page

  return {
    categories,
    order,
    difficulties,
    intensities,
    page,
    instructors,
    focus_areas,
    equipments,
    excludeCompleted,
    per_page: 24
  }
}

export const buildFilterUrl = (filterParams) => {
  let url = []
  let categoryFilters = ''
  let idx = 0

  for (const category in filterParams?.categories) {
    const subcategories = filterParams?.categories?.[category]
    if ((subcategories === 'all' || subcategories.length > 0) && idx > 0) {
      categoryFilters += ','
    }
    if (subcategories === 'all') {
      categoryFilters += category
      idx++
    } else if (subcategories.length > 0) {
      categoryFilters += subcategories.join()
      idx++
    }
  }

  if (categoryFilters?.length > 0) {
    url.push(`categories=${categoryFilters}`)
  }

  if (filterParams.difficulties?.length > 0) {
    url.push(`difficulties=${filterParams.difficulties?.map((item) => item)}`)
  }

  if (filterParams.intensities?.length > 0) {
    url.push(`intensities=${filterParams.intensities.map((item) => item)}`)
  }

  if (filterParams.instructors?.length) {
    url.push(
      `instructors=${filterParams.instructors?.map((item) => item.slug)}`
    )
  }

  if (filterParams?.['focus_area']?.length) {
    url.push(`focus_area=${filterParams['focus_area']?.map((item) => item)}`)
  }

  if (filterParams?.equipment?.length) {
    url.push(`equipment=${filterParams.equipment?.map((item) => item)}`)
  }

  if (filterParams?.excludeCompleted) {
    url.push(`excludeCompleted=${filterParams.excludeCompleted}`)
  }

  if (filterParams?.order) {
    url.push(`order=${filterParams.order}`)
  }

  return url.join('&')
}
